import { createState, createStateInjector, createStateProvider, createStateToken } from '../../state';
import type { UiAccordionItemDirective } from './accordion-item.directive';

/**
 * The state token  for the AccordionItem primitive
 */
export const uiAccordionItemStateToken = createStateToken<UiAccordionItemDirective<unknown>>('AccordionItem');

/**
 * Provides the AccordionItem state
 */
export const provideUiAccordionItemState = createStateProvider(uiAccordionItemStateToken);

/**
 * Injects the AccordionItem state
 */
export const injectUiAccordionItemState = createStateInjector(uiAccordionItemStateToken);

/**
 * The AccordionItem state registration function
 */
export const uiAccordionItemState = createState(uiAccordionItemStateToken);
